import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { isArray } from 'lodash';

import EnhancedAssignOrdersToMapitshipDialog from 'src/modules/Order/components/EnhancedAssignOrdersToMapitshipDialog';

/**
 * AssignOrdersSection - Dialog for assigning orders to MapitShip
 */
function AssignOrdersSection({
    open,
    onClose,
    selectedOrders,
    ordersWithHiddenCards,
    isLoading,
    onSuccess,
    warehouseIssues
}) {
    const formattedOrders = isArray(ordersWithHiddenCards)
        ? ordersWithHiddenCards.map((el) => el?.order)
        : [];

    const hideCards = isArray(ordersWithHiddenCards)
        ? ordersWithHiddenCards.map((el) => el?.hideCards)
        : [];

    return (
        <EnhancedAssignOrdersToMapitshipDialog
            open={open}
            onClose={onClose}
            orders={selectedOrders}
            formattedOrders={formattedOrders}
            hideCards={hideCards}
            isLoading={isLoading}
            onSuccess={onSuccess}
            warehouseIssues={warehouseIssues}
        />
    );
}

AssignOrdersSection.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    selectedOrders: PropTypes.array.isRequired,
    ordersWithHiddenCards: PropTypes.array,
    isLoading: PropTypes.bool,
    onSuccess: PropTypes.func.isRequired,
};

AssignOrdersSection.defaultProps = {
    ordersWithHiddenCards: [],
    isLoading: false,
};

export default memo(AssignOrdersSection);
